import { useState } from "react";
import type * as characterApi from "../api/character";
import type * as mobApi from "../api/mob";
import type * as types from "../lib/types";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "./ui/dialog";
import { Input } from "./ui/input";
import { ScrollArea } from "./ui/scroll-area";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "./ui/tabs";

interface AddParticipantModalProps {
  isOpen: boolean;
  onClose: () => void;
  onJoinCharacter: (
    characterId: string,
    characterName: string,
    characterUniqueName: string,
    character: characterApi.JoinCharacterChatRoomInput,
  ) => void;
  onAddMob: (mob: mobApi.RegisterMobInput) => void;
  availableCharacters: types.Character[];
  remainingSlots: number;
  chatRoomId: string;
  defaultLlmModel: types.LLMModel;
}

export function AddParticipantModal({
  isOpen,
  onClose,
  onJoinCharacter,
  onAddMob,
  availableCharacters,
  remainingSlots,
  chatRoomId,
  defaultLlmModel,
}: AddParticipantModalProps) {
  const [newMobName, setNewMobName] = useState("");

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>参加者を追加 (残り {remainingSlots} 枠)</DialogTitle>
        </DialogHeader>
        <Tabs defaultValue="character">
          <TabsList className="grid w-full grid-cols-2">
            <TabsTrigger value="character">キャラクター</TabsTrigger>
            <TabsTrigger value="mob">モブ</TabsTrigger>
          </TabsList>
          <TabsContent value="character">
            <ScrollArea className="h-[300px]">
              {availableCharacters.length > 0 ? (
                availableCharacters.map((character) => (
                  <div key={character.id} className="flex items-center justify-between p-2 hover:bg-gray-100 rounded">
                    <span>{character.name}</span>
                    <Button
                      size="sm"
                      onClick={() => {
                        onJoinCharacter(character.id, character.name, character.unique_name, {
                          llm_model_id: defaultLlmModel.id,
                          profile: "",
                          scene: "",
                        });
                        onClose();
                      }}
                    >
                      追加
                    </Button>
                  </div>
                ))
              ) : (
                <p className="text-center text-gray-500 mt-4">利用可能なキャラクターがありません</p>
              )}
            </ScrollArea>
          </TabsContent>
          <TabsContent value="mob">
            <div className="space-y-4">
              <Input value={newMobName} onChange={(e) => setNewMobName(e.target.value)} placeholder="モブの名前" />
              <Button
                className="w-full"
                onClick={() => {
                  if (newMobName.trim()) {
                    onAddMob({
                      name: newMobName.trim(),
                      chat_room_id: chatRoomId,
                      profile: "",
                      llm_model_id: "",
                    });
                    setNewMobName("");
                    onClose();
                  }
                }}
                disabled={remainingSlots === 0}
              >
                モブを追加
              </Button>
            </div>
          </TabsContent>
        </Tabs>
        <DialogFooter>
          <Button onClick={onClose} variant="outline">
            キャンセル
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
